import * as React from 'react';
import Button from '@material-ui/core/Button';
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles'

const styles = (theme: Theme) => createStyles({
    primaryDialogButton: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
      fontWeight: 'bold',
      letterSpacing: 0.7,
      // borderRadius: 2,
      marginTop: 0,
      paddingTop: 7,
      paddingBottom: 5,
      marginLeft: "0px",
      textTransform: "uppercase",
      "&:hover": {
        color: theme.palette.secondary.contrastText,
        backgroundColor: theme.palette.secondary.light,
      }
    },
    secondaryDialogButton: {
      backgroundColor: theme.palette.primary.light,
      borderWidth: 0,
      borderColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
      fontWeight: 'bold',
      letterSpacing: 0.7,
      // borderRadius: 2,
      marginTop: 0,
      paddingTop: 7,
      paddingBottom: 5,
      marginLeft: 0,
      textTransform: "uppercase",
    },
    tertiaryDialogButton: {
      fontWeight: 'bold',
      color: theme.palette.primary.contrastText,
      paddingLeft: 0,
      paddingRight: theme.spacing( 0),
      textTransform: "uppercase",
      backgroundColor: "rgba(0,0,0,0%)"
    }
})

interface IDialogButtonProps {
    onClick?: any
    type?: string, 
    variant?: any
    disabled?: boolean
    fullWidth?: boolean
    customClassName?: string
    id?: string
}
  
class DialogButton extends React.Component<WithStyles<typeof styles> & IDialogButtonProps> {
      render() {
        const { classes, onClick, disabled, fullWidth } = this.props

        const typeProp = this.props.type || "button"
        const variantProp = this.props.variant || "contained"
        const childrenProp = this.props.children || 'Button'

        let variant: any
        let className: any = this.props.customClassName ? this.props.customClassName : null
        let color: any
        let type: any

        switch (variantProp) {
            case "primary":
                variant = "contained"
                className = className ? className : classes.primaryDialogButton
                color = "primary"
                type = this.props.type || "submit"
                break
            case "secondary":
                variant = "outlined"
                className = className ? className : classes.secondaryDialogButton
                color = "primary"
                type = typeProp
                break;
            case "tertiary":
                variant = "text"
                className =  className ? className : classes.tertiaryDialogButton
                color = "primary"
                type = typeProp
                break;
            default:
                variant = variantProp
                className = className ? className : classes.primaryDialogButton
                color = "primary"
                type = typeProp
        }
    
        return (
            <Button type={type} 
                className={className}
                size="small"
                variant={variant} 
                color={color} 
                onClick={onClick}
                disabled={disabled}
                fullWidth={fullWidth}
                id={this.props.id}
            >
               {childrenProp}
            </Button>
        )
    }
}

export default withStyles(styles)(DialogButton)
